module.exports = __webpack_public_path__ + "static/media/mobile.19a15a18.svg";